import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import "datatables.net";
import Modal from "react-modal";
import { getStats } from "../store/featureActions";
import { useLocation, useNavigate } from "react-router-dom";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "30%",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
Modal.setAppElement("#root");
const QuickStats = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  const quicStatsData = async (seasonId, userId) => {
    try {
      let payload = {
        params: `?userId=${userId}&seasonId=${seasonId}`,
        isToast: false,
      };
      const response = await dispatch(getStats(payload)).unwrap();
      setStats(response?.data?.stats);
    } catch (rejectedValueOrSerializedError) {
      console.log(rejectedValueOrSerializedError);
    }
  };
  console.log(state)
  useEffect(() => {
    let mount = true;
    if (mount) {
      quicStatsData(state?.type == "user" ? state?.item?.ranking[0]?.seasonId?._id : state?.item?.seasonId?._id, state?.type == "user" ? state?.item?._id : state?.item?.userId?._id)
    }
    return () => {
      mount = false;
    };
  }, [state]);
  useEffect(() => {
    if (!state) {
      navigate("/dashboard")
    }
  }, [state]);
  return (
    <>
      <div className="content-wrapper2">
        <div className="row card_bg" >
          <div className="col-md-12 col-lg-12 stretch-card grid-margin">
            <div className="card bg-gradient-danger card-img-holder text-white ">
              {
                state?.type == "user" ?
                  <div className="card-body card-class">
                    <div className="user_img">
                      <img src={state?.item?.imageName ? state?.item?.imageName : "assets/images/placeholder.jpg"} />
                    </div>
                    <div className="userDetails row mt-3">
                      <div className="col-6">
                        <p>Player Name: <span>{state?.item?.name ? state?.item?.name : "N/A"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Player ID: <span>{state?.item?.id ? `ReelRivals-${state?.item?.id}-${moment().format("YYYY")}` : "N/A"}</span></p>
                      </div>
                      <div className="col-6">
                        <p>Last Login:<span>{state?.item?.lastLogin ? moment(state?.item?.lastLogin).local().format("MM-DD-YYYY hh:mm A") : "N/A"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Global Rank:<span>{stats?.rank ? stats?.rank : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Subscription: <span>
                          {state?.item?.packageType ? state?.item?.packageType.charAt(0).toUpperCase() + state?.item?.packageType.slice(1) + ` (Ends ${moment(state?.item?.expiryDate).format("DD-MMM-YYYY")})` : "Trial" + ` (Ends ${moment(state?.item?.expiryDate).format("DD-MMM-YYYY")})`}
                        </span> </p>
                      </div>
                    </div>
                    <div className="row mt-3 user_InnerDetail">
                      <div className="col-6">
                        <h5 className="mb-3">QUICK STATS</h5>
                      </div>
                      <div className="col-6">
                        {state?.type == "user" ?
                          <select onChange={(e) => quicStatsData(e.target?.value, state?.item?._id)}>
                            {state?.item?.ranking?.map((item, i) => {
                              return <option key={i} value={item?.seasonId?._id}>{item?.seasonId?.seasonName}</option>;
                            })}
                          </select>
                          : <>Season: {state?.item?.seasonId?.seasonName}</>}
                      </div>
                      <div className="col-6">
                        <p>Level:<span>{stats?.level ? stats?.level : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>PPH:<span>{stats?.pph ? stats?.pph?.toFixed(2) : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Total Catches:<span>{stats?.totalCatchLogs ? stats?.totalCatchLogs : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>One-on-One Win %:<span>{stats?.oneOnOneWinPercentage ? stats?.oneOnOneWinPercentage + "%" : 0 + "%"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Single Tournament Win %:<span>{stats?.singleWinPercentage ? stats?.singleWinPercentage + "%" : 0 + "%"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Team Tournament Win %:<span> {stats?.teamWinPercentage ? stats?.teamWinPercentage + "%" : 0 + "%"}</span></p>
                      </div>
                    </div>
                    <div className="row mt-3 user_InnerDetail">
                      <div className="col-12">
                        <h5 className="mb-3">Games Played</h5>
                      </div>
                      <div className="col-6">
                        <p>Solo:<span>{stats?.totalSoloGames ? stats?.totalSoloGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Drop In:<span>{stats?.totalDropInGames ? stats?.totalDropInGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>One-on-One:<span>{stats?.totalOneOnOneGames ? stats?.totalOneOnOneGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Single Tournament:<span>{stats?.totalSingleGames ? stats?.totalSingleGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Team Tournament:<span> {stats?.totalTeamGames ? stats?.totalTeamGames : 0}</span></p>
                      </div>
                    </div>
                  </div>
                  :
                  <div className="card-body card-class">
                    <div className="user_img">
                      <img src={state?.item?.userId?.imageName ? state?.item?.userId?.imageName : "assets/images/placeholder.jpg"} />
                    </div>
                    <div className="userDetails row mt-3">
                      <div className="col-6">
                        <p>Player Name: <span>{state?.item?.userId?.name ? state?.item?.userId?.name : "N/A"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Player ID: <span>{state?.item?.userId?.id ? `ReelRivals-${state?.item?.userId?.id}-${moment().format("YYYY")}` : "N/A"}</span></p>
                      </div>
                      <div className="col-6">
                        <p>Last Login:<span>{state?.item?.userId?.lastLogin ? moment(state?.item?.userId?.lastLogin).local().format("MM-DD-YYYY hh:mm A") : "N/A"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Global Rank:<span>{stats?.rank ? stats?.rank : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Subscription: <span>{state?.item?.userId?.packageType ? state?.item?.userId?.packageType.charAt(0).toUpperCase() + state?.item?.userId?.packageType.slice(1) + ` (Ends ${moment(state?.item?.userId?.expiryDate).format("DD-MMM-YYYY")})` : "N/A"}</span> </p>
                      </div>
                    </div>
                    <div className="row mt-3 user_InnerDetail">
                      <div className="col-6">
                        <h5 className="mb-3">QUICK STATS</h5>
                      </div>
                      <div className="col-6">
                        {state?.type == "user" ?
                          <select onChange={(e) => quicStatsData(e.target?.value, state?.item?.userId?._id)}>
                            {state?.item?.userId?.ranking?.map((item, i) => {
                              return <option key={i} value={item?.seasonId?._id}>{item?.seasonId?.seasonName}</option>;
                            })}
                          </select>
                          : <>Season: {state?.item?.seasonId?.seasonName}</>}
                      </div>
                      <div className="col-6">
                        <p>Level:<span>{stats?.level ? stats?.level : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>PPH:<span>{stats?.pph ? stats?.pph?.toFixed(2) : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Total Catches:<span>{stats?.totalCatchLogs ? stats?.totalCatchLogs : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>One-on-One Win %:<span>{stats?.oneOnOneWinPercentage ? stats?.oneOnOneWinPercentage + "%" : 0 + "%"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Single Tournament Win %:<span>{stats?.singleWinPercentage ? stats?.singleWinPercentage + "%" : 0 + "%"}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Team Tournament Win %:<span> {stats?.teamWinPercentage ? stats?.teamWinPercentage + "%" : 0 + "%"}</span></p>
                      </div>
                    </div>
                    <div className="row mt-3 user_InnerDetail">
                      <div className="col-12">
                        <h5 className="mb-3">Games Played</h5>
                      </div>
                      <div className="col-6">
                        <p>Solo:<span>{stats?.totalSoloGames ? stats?.totalSoloGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Drop In:<span>{stats?.totalDropInGames ? stats?.totalDropInGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>One-on-One:<span>{stats?.totalOneOnOneGames ? stats?.totalOneOnOneGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Single Tournament:<span>{stats?.totalSingleGames ? stats?.totalSingleGames : 0}</span> </p>
                      </div>
                      <div className="col-6">
                        <p>Team Tournament:<span> {stats?.totalTeamGames ? stats?.totalTeamGames : 0}</span></p>
                      </div>
                    </div>
                  </div>
              }
            </div>
          </div>
          <div >

          </div>
        </div>
      </div>

    </>
  );
};
export default QuickStats;
